import {del, post, put} from "../util/http.service";

export const createTransactionCategory = category => post("/transaction-categories", category);

export const updateTransactionCategory = (id, category) => put("/transaction-categories/" + id, category);

export const deleteTransactionCategory = id => del("/transaction-categories/" + id);
